export const config = {
    company_name: "StockAnts",
    
    // export const colorArr = [
        //     "#64c3d1",
//     "#fbc02d",
//     '#cb7cc0',
//     '#98b433',
//     "#86c06a",
//     "#c2b89d",
//     "#d93d42",
//     "#e2f9ff",
//     "#775dd0"
// ]

colorArr: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#3F51B5', '#03A9F4', '#4CAF50', '#F9CE1D', '#FF9800', '#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#4ECDC4', '#C7F464', '#81D4FA', '#fd7b6c', '#546E7A'],

notificationPosition: "top-center",

paginationSize: "medium"
// small | medium | large

// "top-left" | "top-center" | "top-right" | "bottom-left" | "bottom-center" | "bottom-right";
};